import { createAction } from 'redux-actions';

import EventBusEventName from './EventBusEventName';
import { EventCallback } from './EventBusService';

const domain = 'teamleader/Services/EventBusService';

export const ADD_LISTENER = `${domain}/ADD_LISTENER`;
export const REMOVE_LISTENER = `${domain}/REMOVE_LISTENER`;

export const addListener = createAction(ADD_LISTENER, (eventName: EventBusEventName, callback: EventCallback<any>) => {
  return {
    eventName,
    callback: callback,
  };
});

export const removeListener = createAction(
  REMOVE_LISTENER,
  (eventName: EventBusEventName, callback: EventCallback<any>) => ({
    eventName,
    callback,
  }),
);

export type Actions = ReturnType<typeof addListener> | ReturnType<typeof removeListener>;
